<script lang="ts">
	import ArrowLeft from './arrowLeft.svg.svelte';
	interface Props {
		className?: string;
	}

	let { className = 'h-full w-full' }: Props = $props();
</script>

<ArrowLeft {className} rotate />
